<template>
  <div class="company-info-container">
    <el-tabs v-model="tabActive">
      <el-tab-pane label="Company Info" name="company">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span><i class="el-icon-info"></i> Company Info</span>
            <el-button style="margin-right:10px;padding: 3px 0;float:right" icon="el-icon-edit" type="text" @click="editCompany()">Edit</el-button>
          </div>

          <div class="company-info">
            <el-row :gutter="80">
              <el-col :xs="24" :sm="24" :md="12" :lg="12">
                <div>
                  <svg-icon icon-class="company" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Company Name"
                    placement="right"
                  >
                    <p>
                      <el-tag>{{ dataCompany.company_name }}</el-tag>
                    </p>
                  </el-tooltip>
                </div>
                <div>
                  <svg-icon icon-class="email" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Email Contact"
                    placement="right"
                  >
                    <p>
                      <el-tag>{{ dataCompany.email_contact }}</el-tag>
                    </p>
                  </el-tooltip>
                </div>
                <div>
                  <svg-icon icon-class="phone" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Phone Number"
                    placement="right"
                  >
                    <p>
                      <el-tag>{{ dataCompany.phone_number }}</el-tag>
                    </p>
                  </el-tooltip>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12">
                <div>
                  <svg-icon icon-class="www" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Website"
                    placement="right"
                  >
                    <p>
                      <el-tag>{{ dataCompany.website }}</el-tag>
                    </p>
                  </el-tooltip>
                </div>
                <div>
                  <svg-icon icon-class="connect" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Status"
                    placement="right"
                  >
                    <p style="text-transform: capitalize">
                      <el-tag
                        :type="
                          dataCompany.status === 'active' ? 'success' : 'danger'
                        "
                        >{{ dataCompany.status }}</el-tag
                      >
                    </p>
                  </el-tooltip>
                </div>
                <div>
                  <svg-icon icon-class="api" />
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Token API"
                    placement="right"
                  >
                    <p>
                      <el-tag>{{ dataCompany.token }}</el-tag>
                    </p>
                  </el-tooltip>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-tab-pane>

      <el-tab-pane label="Projects" name="project">
        <ProjectManager :companyUID="$route.params.uid" />
      </el-tab-pane>

      <el-tab-pane label="Users" name="user">
        <UserManager :companyUID="$route.params.uid" />
      </el-tab-pane>

      <el-tab-pane label="IP Server" name="ips">
        <IPServer :companyUID="$route.params.uid" />
      </el-tab-pane>

      <el-tab-pane label="Report" name="report">
        <Report :companyUID="$route.params.uid" />
      </el-tab-pane>

      <el-tab-pane label="Security" name="security" v-if="superAdminRole">
        <Security :companyUID="$route.params.uid" />
      </el-tab-pane>
    </el-tabs>
    
  </div>
</template>

<script>
import { getCompanyBy } from "@/api/company";
import UserManager from "@/views/user/components/user-manager";
import ProjectManager from "@/views/project/components/project-manager";
import Report from "@/views/company/components/company-report"
import Security from "@/views/company/components/security"
import IPServer from "@/views/ip-server/index"

export default {
  components: {
    UserManager,
    ProjectManager,
    IPServer,
    Report,
    Security
  },
  computed: {
    superAdminRole() {
      return this.roleAuth([this.role.spadmin]);
    }
  },
  data() {
    return {
      loadingProject: false,
      dataCompany: {},
      tabActive:"company",
      dialogFormVisible: false,
      companyForm: {}
    };
  },
  methods: {
    getCompanyInfo() {
      const loading = this.$loading({ text: "Loading data..." });
      getCompanyBy(this.$route.params.uid).then(async ({ result, data }) => {
        loading.close();
        if (result) {
          this.dataCompany = data;
          await this.$store.dispatch('user/setCompany', data)
        }
      });
    },

    editCompany(){
      this.$router.push(`/company/edit/${this.$route.params.uid}?ref=info`)
    },
    onSubmited(){
      this.getCompanyInfo()
    }
  },
  created() {
    this.getCompanyInfo();
  },
};
</script>

<style lang="scss">
.company-info-container {
  .company-info {
    // display: inline-block;
    // vertical-align: top;

    div .svg-icon {
      // background-color: #757575;
      // color: #ffffff;
      font-size: 32px;
      // width: 30px;
      // height: 30px;
      // border-radius: 50%;
      text-align: center;
      // line-height: 32px;
      margin: 5px 15px;
      vertical-align: middle;
    }

    div p {
      display: inline-block;
      color: #303133;
      vertical-align: middle;
      margin: 0;
    }
    div p .el-tag {
      font-size: 14px;
    }
  }
}
</style>